var _g, _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSoftballWarningMarker = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 46,
    viewBox: "0 0 33 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.5,
    cy: 40,
    rx: 10.5,
    ry: 3,
    fill: "black",
    fillOpacity: 0.25
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4643 40C16.4426 40 16.4206 39.9993 16.399 39.9979C16.1782 40.0118 15.955 39.9558 15.7626 39.8302C12.2444 37.5346 8.95292 34.2443 6.24425 30.3151C2.76486 25.2683 0.769287 19.9183 0.769287 15.6369C0.769287 13.4582 1.21016 11.3478 2.07967 9.36447C4.57403 3.67579 10.1975 0 16.406 0C25.0202 0 32.0284 7.01459 32.0284 15.6369C32.0284 20.1859 29.7207 26.0396 25.8554 31.2954C23.2843 34.7915 20.2343 37.7428 17.0351 39.8303C16.8612 39.9437 16.6625 40 16.4643 40Z",
    fill: "#FE9800"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      transform: "scale(.4)",
      transformOrigin: "8px 8px"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 51a23.453 23.453 0 01-12.173-3.395.499.499 0 01-.085-.79c4.259-4.057 6.905-11.459 6.905-19.315s-2.646-15.258-6.905-19.316a.5.5 0 01.085-.789A23.453 23.453 0 0127.5 4c4.303 0 8.513 1.174 12.172 3.395a.499.499 0 01.086.79c-4.26 4.057-6.905 11.459-6.905 19.315s2.646 15.258 6.905 19.316a.5.5 0 01-.086.789A23.453 23.453 0 0127.5 51zm-11.1-3.924A22.47 22.47 0 0027.5 50a22.47 22.47 0 0011.1-2.924c-4.236-4.367-6.747-11.62-6.747-19.576S34.364 12.291 38.6 7.924A22.47 22.47 0 0027.5 5a22.47 22.47 0 00-11.1 2.924c4.235 4.367 6.747 11.62 6.747 19.576s-2.512 15.209-6.748 19.576z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.586 47.678a.497.497 0 01-.259-.073C8.234 43.302 4 35.786 4 27.5S8.234 11.698 15.327 7.395a.5.5 0 01.604.065c4.519 4.305 7.216 11.796 7.216 20.04s-2.697 15.735-7.216 20.04a.498.498 0 01-.345.138zm-.07-39.225C8.924 12.604 5 19.695 5 27.5s3.923 14.896 10.517 19.047c4.097-4.111 6.63-11.361 6.63-19.047s-2.533-14.936-6.63-19.047zM39.413 47.678a.498.498 0 01-.345-.138c-4.518-4.305-7.215-11.796-7.215-20.04s2.697-15.735 7.215-20.04a.497.497 0 01.604-.065C46.766 11.698 51 19.215 51 27.5s-4.234 15.802-11.328 20.105a.497.497 0 01-.259.073zm.07-39.225c-4.098 4.111-6.63 11.361-6.63 19.047s2.532 14.936 6.63 19.047C46.077 42.396 50 35.305 50 27.5S46.077 12.604 39.483 8.453z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f",
    x: 3,
    y: 34,
    width: 27,
    height: 12,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "effect1_foregroundBlur"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSoftballWarningMarker);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/SoftballWarningMarker.e61df50a97bf91d16845b16008b5dbff.svg";